<template>
	<div v-show="show" style="background-color: rgba(0,0,0,0.3);width: 100vw;height:100vh;z-index: 9999;position: fixed;top: 0;left: 0;">
		<el-dialog
		  title="请假管理"
		  :visible.sync="show"
		  width="50%">
		  <div style="width: 100%;height: 60vh;overflow-y:auto;padding: 20px;font-size: 16px;">
			  <div style="margin-bottom: 10px;">请假人数<span style="color:#277bf5">({{qingjiaList.length}}人)</span></div>
			  
			  <div style="width:100%;">
			  	<div style="width: 100%;padding: 10px 0;border-bottom: 1px solid #eee;" v-for="item in qingjiaList">
					<div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
						<div style="color: #333;font-size:16px;font-weight: bold;">
							{{item.name?item.name:'报名人员'}}
						</div>
						<div style="font-size: 14px;">
							<span style="margin-right: 10px;">提交时间：</span><span style="color:#333;">{{item.cztime}}</span>
						</div>
					</div>
			  		<div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
			  			<div style="font-size: 14px;">
			  				<span style="margin-right: 10px;">请假原因：</span><span style="color:#333;">{{item.liyou}}</span>
			  			</div>
			  			<div style="font-size: 14px;">
			  				<span style="margin-right: 10px;">代参会人：</span><span style="color:#333;">{{item.duser_name?item.duser_name:'无'}}</span>
			  			</div>
			  		</div>
			  	</div>
			  </div>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="show = false">取 消</el-button>
		    <el-button type="primary" @click="show = false">确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				show:false,
				id:'',
				qingjiaList:[]
			}
		},
		methods:{
			getlist(){
				this.$post({
					url: '/api/invest_research_wymeeting/hyry',
					params: {
						wymeeting_id:this.id,
						type:4
					}
				}).then((res) => {
					this.qingjiaList = res.data.list
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	
</style>